import _ from "lodash";
import ElementGroup from "./ElementGroup";
import StackLayoutStrategy from "./StackLayoutStrategy";

class MobileGroupAutoLayoutStrategy {
  constructor(/** Object **/ config = {}) {
    this.config = config;
    this.maxWidth = _.get(this.config, "maxWidth", 320);
    this.elementMinWidth = _.get(this.config, "elementMinWidth", 100);
    this.yPadding = _.get(this.config, "yPadding", 10);
  }

  apply(/** ElementGroup **/ group) {
    let maxWidth = this.maxWidth;
    let minElemWidth = this.elementMinWidth;
    let yPadding = this.yPadding;

    let numElements = group.elements.length;

    group.width = Math.min(group.bounds.w, maxWidth);
    if (numElements == 1) {
      group.width = Math.max(minElemWidth, group.width);
    }

    let isHorizontal = group.bounds.w > group.bounds.h;

    let widthScale = group.width / group.bounds.w;

    let backgroundElements = [];
    let toStackElements = [];

    let totalElementsWidth = 0;

    _.each(group.elements, function (elementData) {
      let localRect = _.get(elementData, "localRect");
      let aspectRatio = localRect.h / localRect.w;

      //check to see if element fills whole group
      if (numElements > 1 && localRect.w == group.bounds.w && localRect.h == group.bounds.h) {
        backgroundElements.push(elementData);
        _.set(elementData, "isBG", true);
      }

      localRect.w = Math.max(
        minElemWidth,
        Math.min(maxWidth, Math.round(widthScale * localRect.w))
      );
      localRect.x = Math.round(widthScale * localRect.x);

      let scaledHeight = Math.round(aspectRatio * localRect.w);

      localRect.y = Math.round((scaledHeight / localRect.h) * localRect.y);
      localRect.h = scaledHeight;

      localRect.x2 = localRect.x + localRect.w;
      localRect.y2 = localRect.y + localRect.h;

      if (localRect.y2 > group.height) {
        group.height = localRect.y2;
      }

      totalElementsWidth += localRect.w;
    });

    //After adjusting all element widths total width is to wide so stack elements instead
    if (totalElementsWidth > group.width) {
      _.each(group.elements, function (elementData) {
        if (!_.has(elementData, "isBG")) {
          toStackElements.push(elementData);
        }
      });
    }

    if (!_.isEmpty(toStackElements)) {
      var stackGroup = new ElementGroup();
      stackGroup.elements = toStackElements;
      stackGroup.prepare();

      var stackConfig = _.clone(this.config);

      var stackLayout = new StackLayoutStrategy(stackConfig);
      stackLayout.apply(stackGroup);

      group.height = stackGroup.height;
    }

    group.height = group.height + yPadding;

    _.each(backgroundElements, function (elementData) {
      let localRect = _.get(elementData, "localRect");
      localRect.x = 0;
      localRect.y = 0;
      localRect.h = group.height;
      localRect.w = group.width;
    });
  }
}

export default MobileGroupAutoLayoutStrategy;
